import React from 'react';
import TextInput from '../../form/TextInput';
import createForm from "./Form";
import DateTimeInput from "../../form/DateTimeInput";
import TypeTextEditor from "../../form/TypeTextEditor";

class CampaignForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-1 col-sm-push-11">
                        <TextInput
                            name={this.props.componentConfig.idfield}
                            value={this.props.values[this.props.componentConfig.idfield]}
                            label="Kód"
                            role="idfield"
                        />
                    </div>
                    <div className="col-sm-11 col-sm-pull-1">
                        <TextInput
                            name="name"
                            value={this.props.values.name}
                            label="Név"
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-6">
                        <DateTimeInput
                            name="start_date"
                            value={this.props.values.start_date}
                            label="Kezdés"
                            showTime={true}
                            isClearable={true}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-sm-6">
                        <DateTimeInput
                            name="end_date"
                            value={this.props.values.end_date}
                            label="Vég"
                            showTime={true}
                            isClearable={true}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <TypeTextEditor
                            name="description"
                            label="Leírás"
                            data={this.props.values}
                            componentConfig={this.props.componentConfig}
                            getFieldProps={this.props.getFieldProps}
                            setFieldValue={this.props.setFieldValue}
                        />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(CampaignForm);
